import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Dropdown, { DropdownItem } from '../common/Dropdown';
import Avatar from '../common/Avatar';
import Divider from '../common/Divider';
import { logout } from '../../store/slices/authSlice';
import { theme } from '../../config/theme';
import { UserIcon, SettingsIcon, LogoutIcon, MapPinIcon, ShoppingCartIcon, HeartIcon, UsersIcon } from '../icons/Icons';

const ProfileMenu = ({ user, isMobile }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const getProfileRoute = () => {
    if (user?.role === 'customer') return '/profile';
    if (user?.role === 'seller') return '/seller/profile';
    if (user?.role === 'admin') return '/admin/profile';
    return '/profile';
  };

  const getSettingsRoute = () => {
    if (user?.role === 'customer') return '/settings';
    if (user?.role === 'seller') return '/seller/settings';
    if (user?.role === 'admin') return '/admin/settings';
    return '/settings';
  };

  const triggerStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    cursor: 'pointer',
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.borderRadius.full,
    transition: theme.transitions.fast,
    backgroundColor: 'transparent',
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.backgroundColor = theme.colors.gray[50];
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
  };

  return (
    <Dropdown
      align="right"
      trigger={
        <div 
          style={triggerStyles}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Avatar 
            name={`${user?.first_name || ''} ${user?.last_name || ''}`} 
            size="md"
          />
          {!isMobile && (
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: theme.typography.fontSize.sm, fontWeight: theme.typography.fontWeight.medium }}>
                {user?.first_name} {user?.last_name}
              </div>
              <div style={{ fontSize: theme.typography.fontSize.xs, color: theme.colors.text.secondary, textTransform: 'capitalize' }}>
                {user?.role}
              </div>
            </div>
          )}
        </div>
      }
    >
      <DropdownItem 
        icon={<UserIcon size={18} />} 
        onClick={() => navigate(getProfileRoute())}
      >
        Profile
      </DropdownItem>
      
      {user?.role === 'customer' && (
        <>
          <DropdownItem 
            icon={<ShoppingCartIcon size={18} />} 
            onClick={() => navigate('/cart')}
          >
            Cart
          </DropdownItem>
          <DropdownItem 
            icon={<HeartIcon size={18} />} 
            onClick={() => navigate('/wishlist')}
          >
            Wishlist
          </DropdownItem>
          <DropdownItem 
            icon={<UsersIcon size={18} />} 
            onClick={() => navigate('/following')}
          >
            Following
          </DropdownItem>
          <DropdownItem 
            icon={<MapPinIcon size={18} />} 
            onClick={() => navigate('/addresses')}
          >
            My Addresses
          </DropdownItem>
        </>
      )}
      
      <DropdownItem 
        icon={<SettingsIcon size={18} />} 
        onClick={() => navigate(getSettingsRoute())}
      >
        Settings
      </DropdownItem>
      
      <Divider spacing="sm" />
      
      <DropdownItem 
        icon={<LogoutIcon size={18} />} 
        onClick={handleLogout}
      >
        Logout
      </DropdownItem>
    </Dropdown>
  );
};

export default ProfileMenu;